module.exports = __webpack_public_path__ + "img/about_elaine_header.b8ff6623.jpg";